import React, {Fragment, useMemo} from 'react';
import {Link, Breadcrumbs, Layout, Transition, TransitionGroup, Icon, Flex, Card, Popup, Dropdown, Form, Submit, List} from 'components';
import {moment, preventDefault, token, size, config, capitalize, useNamedSelector, map, toggle, includes} from 'helpers';
import {store} from 'store';
import {forbid} from 'store/session';

export function Export() {
  const { free } = useNamedSelector('session.subscription')
  const { today } = useNamedSelector('calendar.days');
  const { files, status } = useNamedSelector('exported.data');

  const initialValues = useMemo(() => ({
    action: 'export-pdf',
    params: Object.keys(params),
    today: today.format('MM/DD/YYYY'),
  }), []);

  return (
    <Fragment>
      <Form initialValues={initialValues} className="medium-spacing" onSubmit={free ? forbid : submit}>
        <Layout.Header justified>
          <Breadcrumbs>
            <Link to="/settings/">Settings</Link>
            <b>Export</b>
          </Breadcrumbs>
          <Submit className="small" useState={() => ({ isValid: true, isSubmitting: status == 'pending' })}>
            {[ 'Export', 'Exporting..' ]}
          </Submit>
        </Layout.Header>
        <div>
          <List small-gutter>
            <Dropdown label="Format" name="action" Popup={Format}>
              { value =>
                <b>{ value == 'export-pdf' ? 'PDF' : 'Excel' }</b>
              }
            </Dropdown>
            <Dropdown label="Data" name="params" Popup={Options}>
              { value =>
                <b className="one-liner">
                  { value.length == size(params)
                    ? 'Everything'
                    : value.map((key, index) =>
                      <span key={key}>{ index ? ',' : '' } { params[key] }</span>
                      )
                  }
                </b>
              }
            </Dropdown>
          </List>
          { size(files) > 0 &&
            <div className="medium-spacing">
              <h5>Your files</h5>
              <TransitionGroup component={null}>
                { map(files, file =>
                  <Transition key={file.name} timeout={300}>
                    { state =>
                      <Card className={state}>
                        <Card.Body>
                          <Flex small-gutter>
                            <a className="link" href={`https://${config.domain}/o/webservices-portlet/rest/mobile/export-data/${token().token}/${encodeURIComponent(file.name)}`}>
                              { file.name }
                            </a>
                            { file.zip &&
                              <span className="secondary">[ <a className="link" href={`https://${config.domain}/o/webservices-portlet/rest/mobile/export-data/${token().token}/${encodeURIComponent(file.zip.name)}`}>
                                zip
                              </a> ]
                              </span>
                            }
                          </Flex>
                          { file.dateMillis &&
                            <Card.Note>{ moment.unix(file.dateMillis/1000).format('MMM D, YYYY h:mm A') }</Card.Note>
                          }
                        </Card.Body>
                        <Card.Toolbar>
                          <Icon name="trash" onClick={() => remove(file)} />
                        </Card.Toolbar>
                      </Card>
                    }
                  </Transition>
                ) }
              </TransitionGroup>
            </div>
          }
        </div>
      </Form>
    </Fragment>
  );
}

function Format({ value, setValue }) {
  return (
    <Popup.Menu>
      <Popup.Menu.Item pressed={value == 'export-pdf'} onClick={() => setValue('export-pdf')}>PDF</Popup.Menu.Item>
      <Popup.Menu.Item pressed={value == 'export-excel'} onClick={() => setValue('export-excel')}>Excel</Popup.Menu.Item>
    </Popup.Menu>
  );
}

function Options({ value, setValue }) {
  return (
    <Popup.Menu onClick={preventDefault}>
      { map(params, (label, key) =>
        <Popup.Menu.Checkbox
          key={key}
          checked={includes(value, key)}
          children={label}
          className="has-background"
          onClick={() => setValue(toggle(value, key, { min: 1 }))}
        />
      ) }
    </Popup.Menu>
  );
}

function submit(values) {
  store.dispatch({
    type: 'EXPORTED_FILES_REQUEST',
    values,
  });
}

function remove(file) {
  store.dispatch({
    type: 'EXPORTED_FILES_REMOVE',
    files: [ file, file.zip ].filter(Boolean),
  });
}

const params = {
  'reality-check': 'Reality Check',
  'goals': 'My Goals',
  'active-tasks': 'Action Plan',
  'completed': 'Completed Goals and Tasks',
  'weekly-rituals': config.sw ? 'My Routines and Habits' : 'My Routines',
  'todays-targets': 'Today\'s Targets',
  'notes': 'My Notes',
  'journal': 'My Journal',
  'clarity': capitalize(config.clarityModule),
  'starter': capitalize(config.identityModule),
}
